





















import { defineComponent, ref } from '@vue/composition-api'
import { useRouter } from '@intlify/vue-router-bridge'
import type { PropType } from '@vue/composition-api'
import type { RawLocation } from 'vue-router/types/router'

export default defineComponent({
  name: 'UnsavedSettingsDialog',

  props: {
    value: {
      type: Object as PropType<Record<string, unknown>>,
      default: () => ({})
    }
  },

  setup(props) {
    const router = useRouter()

    const targetRoute = ref<RawLocation | null>(null)
    const showDialog = ref(false)

    router.beforeEach((to, from, next) => {
      if (Object.keys(props.value).length && to.name !== from.name && !targetRoute.value) {
        const { name, ...rest } = to
        targetRoute.value = { name: name || undefined, ...rest }
        showDialog.value = true
      } else {
        next()
      }
    })

    const confirmLeave = () => !!targetRoute.value && router.push(targetRoute.value)

    const denyLeave = () => {
      showDialog.value = false
      targetRoute.value = null
    }

    return {
      showDialog,
      confirmLeave,
      denyLeave
    }
  }
})
